import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TabComponent } from '../../../shared/components/tab/tab.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ButtonComponent } from '../../../shared/components/buttons/button/button.component';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import moment from 'moment';
// import {
//   LocaleService,
//   NgxDaterangepickerMd,
// } from 'ngx-daterangepicker-material';
import { ViewportService } from '../../services/viewport.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DualCalendarComponent } from '../dual-calendar/dual-calendar.component';

// Extend dayjs with the customParseFormat plugin
dayjs.extend(customParseFormat);

@Component({
  selector: 'app-departure-modal-web',
  standalone: true,
  imports: [
    TabComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ButtonComponent,
    // NgxDaterangepickerMd,
    MatTooltipModule,
    DualCalendarComponent
  ],
  // providers: [LocaleService],
  templateUrl: './departure-modal-web.component.html',
  styleUrls: ['./departure-modal-web.component.scss'],
})


export class DepartureModalWebComponent {
  @Input() showTabs = true;
  @Input() selectedValue: any;
  @Input() tripDuration: any;
  @Output() selectionChange = new EventEmitter<any>();
  @Input() viewMode: any = 'dual';

  today = new Date();
  weeks = [
    { name: '1st Week', disabled: false },
    { name: '2nd Week', disabled: false },
    { name: '3rd Week', disabled: false },
    { name: '4th Week', disabled: false },
  ];
  months = [
    { name: 'September 2024', disabled: false },
    { name: 'September 2024', disabled: false },
    { name: 'September 2024', disabled: false },
    { name: 'September 2024', disabled: false },
  ];
  minDate: dayjs.Dayjs;
  selectedDateRange: { start: string; end: string } | null = {
    start: moment().format('DD-MM-YYYY'),
    end: moment().format('DD-MM-YYYY'),
  };
  startDate = dayjs().startOf('day');
  endDate = dayjs().startOf('day');

  // Use label instead of name for tabs
  tabs: any[] = [
    { label: 'Fixed', value: 'fixed' },
    { label: 'Flexible', value: 'flexible' },
  ];
  @Input() selectedTabIndex = 0; // Default to first tab
  selectedTab: string = '';

  selectedDate = new Date().getDate();
  nextMonthDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
  currentMonthIndex: string = '';
  // Flexible tab variables
  @Input() selectedWeek: string | null = '';
  @Input() selectedMonth: string | null = '';
  @Input() isMobileView: boolean = false;
  txlButtonWidth: boolean = false;
  rangeDateValue!: {
    departureDate: { start: string; end: string | null };
    departureDuration: number;
    departureType: string;
  };

  constructor(private viewportService: ViewportService) {
    this.minDate = dayjs().startOf('day').add(1, 'day');
    this.viewportService.getViewportWidth().subscribe((width: number) => {
      this.isMobileView = width > 768 ? false : true;
      this.txlButtonWidth = width > 500 ? false : true;
    });
  }

  ngOnInit() {
    this.selectedTab = this.tabs[this.selectedTabIndex]?.value;
    this.months = this.getNextSixMonths();
    if (this.selectedValue) {
      if (this.selectedValue.departureDate) {
        const { start, end } = this.selectedValue.departureDate;
        this.selectedDateRange = {
          start: moment(start, 'DD-MM-YYYY').format('DD-MM-YYYY'),
          end: moment(start, 'DD-MM-YYYY')
            .add(this.tripDuration - 1, 'day')
            .format('DD-MM-YYYY'),
        };
        this.startDate = dayjs(start, 'DD-MM-YYYY');
        this.endDate = this.startDate;

        // Only set end date for desktop view
        if (!this.isMobileView)
          this.endDate = dayjs(start, 'DD-MM-YYYY').add(
            this.tripDuration - 1,
            'day'
          );
      } else {
        this.selectedTabIndex = 1;
        this.selectedTab = this.tabs[this.selectedTabIndex]?.value;
        this.selectedMonth = this.selectedValue.departureMonth;
        this.selectedWeek = this.selectedValue.departureWeek;
        this.isMonthDisable();
        this.isWeekDisabled();
      }
    }


  }

  onDateRangeChange(event: { start: Date; end: Date | null }) {
    if (!event.start) return;

    const formattedStart = moment(event.start).format('DD-MM-YYYY');
    const formattedEnd = event.end ? moment(event.end).format('DD-MM-YYYY') : null;

    const start = moment(event.start);
    const end = event.end ? moment(event.end) : start;
    const duration = end.diff(start, 'days') + 1;

    const result = {
      departureDate: {
        start: formattedStart,
        end: formattedEnd,
      },
      departureDuration: duration,
      departureType: 'fixed',
    };

    this.rangeDateValue = result;
  }



  onTabChange(index: number): void {
    const selectedTab = this.tabs[index]?.value;
    if (selectedTab) {
      this.selectedTab = selectedTab;
    }
  }

  selectWeek(week: string) {
    this.selectedWeek = week;
    this.isMonthDisable();
  }

  selectMonth(month: string) {
    this.selectedMonth = month;
    this.isWeekDisabled();
  }

  onDateRangeSelected(event: any): void {
    console.log(event, 'event');
    this.selectedDateRange = {
      start:
        event?.startDate?.format('DD-MM-YYYY') || this.selectedDateRange?.start,
      end: event?.endDate?.format('DD-MM-YYYY') || this.selectedDateRange?.end,
    };
  }

  applySelectedFilters() {
    let filters;
    if (this.selectedTab === 'fixed') {
      // const startDate = moment(this.selectedDateRange?.start, 'DD-MM-YYYY');
      // let endDate = moment(
      //   this.selectedDateRange?.end || this.selectedDateRange?.start,
      //   'DD-MM-YYYY'
      // );
      // if (endDate.diff(startDate, 'days') < 0) endDate = startDate;
      // const duration = endDate.diff(startDate, 'days') + 1;
      // filters = {
      //   departureType: this.selectedTab,
      //   departureDate: this.selectedDateRange,
      //   departureDuration: duration,
      // };
      filters = this.rangeDateValue
    } else {
      filters = {
        departureType: this.selectedTab,
        departureWeek: this.selectedWeek,
        departureMonth: this.selectedMonth,
        departureDuration: 7,
      };
    }
    this.selectionChange.emit(filters);
  }

  isApplyDisabled(): boolean {
    if (this.rangeDateValue) {
      return false
    }
    if (this.selectedTab === 'flexible') {
      return !(this.selectedWeek && this.selectedMonth); // Disable if week or month is not selected
    }
    return true; // Enable in all other cases
  }

  getNextSixMonths() {
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    return Array.from({ length: 12 }, (_, i) => {
      const today = new Date();
      const date = new Date(today.getFullYear(), today.getMonth() + i, 1);

      return {
        name: `${monthNames[date.getMonth()]} ${date.getFullYear()}`,
        disabled: false, // Default to false; this will be updated based on conditions
      };
    });
  }

  isMonthDisable() {
    const currentMonthName = new Date().toLocaleString('default', {
      month: 'long',
    });
    const currentYear = new Date().getFullYear();
    this.currentMonthIndex = `${currentMonthName} ${currentYear}`;
    const weekPassed =
      (this.selectedWeek === '1st Week' && this.selectedDate > 7) ||
      (this.selectedWeek === '2nd Week' && this.selectedDate > 14) ||
      (this.selectedWeek === '3rd Week' && this.selectedDate > 21) ||
      (this.selectedWeek === '4th Week' && this.selectedDate > 28);
    if (weekPassed) {
      this.disableCurrentMonth(this.currentMonthIndex);
    } else {
      this.enableCurrentMonth(this.currentMonthIndex);
    }
  }

  isWeekDisabled() {
    const currentMonthName = new Date().toLocaleString('default', {
      month: 'long',
    });
    const currentYear = new Date().getFullYear();
    const currentMonthYear = `${currentMonthName} ${currentYear}`;
    if (this.selectedMonth === currentMonthYear) {
      const currentDay = this.selectedDate;
      this.weeks.forEach((week) => {
        week.disabled =
          (week.name === '1st Week' && currentDay > 7) ||
          (week.name === '2nd Week' && currentDay > 14) ||
          (week.name === '3rd Week' && currentDay > 21) ||
          (week.name === '4th Week' && currentDay > 28);
      });
    } else {
      this.weeks.forEach((week) => (week.disabled = false));
    }
  }

  disableCurrentMonth(month: string) {
    const monthObj = this.months.find((m) => m.name === month);
    if (monthObj) {
      monthObj.disabled = true;
    }
  }

  enableCurrentMonth(month: string) {
    const monthObj = this.months.find((m) => m.name === month);
    if (monthObj) {
      monthObj.disabled = false;
    }
  }
}
